module.exports = __webpack_public_path__ + "img/icon2.4f462867.svg";